import {NumberFormatter} from "./number-util";

class InvoicePriceCalculator {
    static calculate(pos, item, hid) {
        window.require(["dojo/dom", "dijit/registry", "dojo/currency"], function (dom, registry, number) {
            try {


                const quantity = NumberFormatter.numberFromLocaleString(String(window.dojo.byId('QUANTITY_' + pos + hid).value));
                const invp = NumberFormatter.numberFromLocaleString(String(window.dojo.byId('INVP_' + pos + hid).value));
                const invtax = NumberFormatter.numberFromLocaleString(String(window.dojo.byId('INVTAX_' + pos + hid).value));
                const anzPositionen = window.dojo.byId('anzPositionen').value;

                let price_line_amount = quantity * invp;
                price_line_amount = InvoicePriceCalculator.extround(price_line_amount, 100);

                const formattedPriceLineAmount = number.format(price_line_amount);

                window.dojo.byId('PRICE_LINE_AMOUNT_' + pos + hid).value = formattedPriceLineAmount;
                window.dojo.byId('DIV_PRICE_LINE_AMOUNT_' + pos + hid).innerHTML = formattedPriceLineAmount;

                let sum = 0;
                let sum_tax = 0;

                for (var i = 1; i <= anzPositionen; i++) {
                    var itemPrice = 0;

                    // check ob nur fracht bearbeitet werden darf
                    if (typeof registry.byId('INVP_' + i + hid) != 'undefined') {
                        itemPrice = registry.byId('INVP_' + i + hid).get('value');
                    } else {
                        itemPrice = window.dojo.byId('INVP_' + i + hid).value;
                    }

                    let itemTaxRate;
                    if (typeof registry.byId('INVTAX_' + i + hid) != 'undefined') {
                        itemTaxRate = NumberFormatter.numberFromLocaleString(registry.byId('INVTAX_' + i + hid).get('value'));
                    } else {
                        itemTaxRate = NumberFormatter.numberFromLocaleString(window.dojo.byId('INVTAX_' + i + hid).value);
                    }
                    sum = sum + itemPrice * NumberFormatter.numberFromLocaleString(window.dojo.byId('QUANTITY_' + i + hid).value);
                    sum_tax = sum_tax + (itemPrice * NumberFormatter.numberFromLocaleString(window.dojo.byId('QUANTITY_' + i + hid).value) * (itemTaxRate / 100));
                }
                sum = InvoicePriceCalculator.extround(sum, 100);
                sum_tax = InvoicePriceCalculator.extround(sum_tax, 100);

                let sum_total = parseFloat(sum) + parseFloat(sum_tax);
                sum_total = InvoicePriceCalculator.extround(sum_total, 100);

                window.dojo.byId('SUM' + hid).value = number.format(sum);
                window.dojo.byId('SUM_TAX' + hid).value = number.format(sum_tax);
                window.dojo.byId('SUM_TOTAL' + hid).value = number.format(sum_total);

                window.dojo.byId('DIV_SUM' + hid).innerHTML = number.format(sum);
                window.dojo.byId('DIV_SUM_TAX' + hid).innerHTML = number.format(sum_tax);
                window.dojo.byId('DIV_SUM_TOTAL' + hid).innerHTML = number.format(sum_total);

                //umsetzen des wertes der hidden variablen
                window.dojo.byId('INVP_HIDDEN_' + item + hid).value = invp;
                window.dojo.byId('INVTAX_HIDDEN_' + item + hid).value = invtax;


                if (window.dojo.byId('ITEMS' + hid).value == '') {
                    window.dojo.byId('ITEMS' + hid).value = item;
                } else {
                    window.dojo.byId('ITEMS' + hid).value = window.dojo.byId('ITEMS' + hid).value + ',' + item;
                }

                if (window.dojo.byId('INVPS' + hid).value == '') {
                    window.dojo.byId('INVPS' + hid).value = invp;
                } else {
                    window.dojo.byId('INVPS' + hid).value = window.dojo.byId('INVPS' + hid).value + ',' + invp;
                }
            } catch (e) {
                // log error here because dojo hides them otherwise eventually
                console.error(e);
            }
        });
    }

    static extround(zahl, n_stelle) {
        zahl = (Math.round(zahl * n_stelle) / n_stelle);
        zahl = zahl.toFixed(2);

        return zahl;
    }
}

window.InvoicePriceCalculator = InvoicePriceCalculator;